<template>
    <!-- Affirm -->
    <div v-if="paymentOptions.filter(x => x.Provider == 'Affirm') != null && activePartnumber.Price >= 1999">
        <div class="financing-available clearfix track-GA4-event" style="min-height:26px;" data-ga4_name="financing_prequalify" :data-ga4_model_category="activePartnumber.GA_Category" :data-ga4_model_name="activePartnumber.GA_ModelName" data-ga4_click_text="prequalify now">
            <p class="affirm-as-low-as track-GA4-event" :data-amount="activePartnumber.Price * 100" data-promo-id="TODO" data-affirm-color="blue" data-ga4_name="financing_prequalify" :data-ga4_model_category="activePartnumber.GA_Category" :data-ga4_model_name="activePartnumber.GA_ModelName" data-ga4_click_text="prequalify now"></p>
        </div>
    </div>
</template>
<script>
    import generalMixin from '../../mixins/general.js';
    export default {
        name: 'Affirm',
        mixins: [generalMixin],
        props: ['activePartnumber'],
        data: function () {
            return {
                paymentOptions: window.paymentOptions,
                cdn: window.cdn
            }
        },
        methods: {
            
        },
        computed: {
            
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
        }
    }
</script>
